import { useState } from "react";

import { NotificationExpandToggle } from "./NotificationExpandToggle";
import { Column, Row, Text } from "@/components";
import { AgenticScoreChip } from "@jobs/pipeline/shared/AgenticScoreChip";

import { agenticScoreToBucket } from "@/lib/agenticScore";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_NOTIFICATION_SURFACES, MIXPANEL_SCREENS } from "@/lib/mixpanel/types";
import { getCandidacyLink } from "@/lib/notificationLinks";
import { cn } from "@/lib/utils";
import { NotificationExpiringCandidatesPayload, NotificationType } from "@/types";

export const NotificationExpiringCandidacyList = ({
  isCompact = false,
  payload,
  trackingSurface,
}: {
  isCompact?: boolean;
  payload: NotificationExpiringCandidatesPayload;
  trackingSurface: MIXPANEL_NOTIFICATION_SURFACES;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { candidacies } = payload;

  const render = () => (
    <Column className="gap-0.5">
      <NotificationExpandToggle
        isExpanded={isExpanded}
        notificationType={NotificationType.EXPIRING_CANDIDATES}
        setIsExpanded={setIsExpanded}
        trackingSurface={trackingSurface}
      >
        {candidacies.length}{" "}
        {candidacies.length === 1 ? "candidate" : "candidates"}
      </NotificationExpandToggle>
      {isExpanded ? (
        <Column className="gap-1 border-l border-slate-200 pl-3 pt-1">
          {candidacies.map((candidacy) => {
            const bucket = agenticScoreToBucket(candidacy.candidateRating);
            return (
              <Column
                key={candidacy.candidacyId}
                className="cursor-pointer gap-0 rounded-md px-2 py-1.5 hover:bg-slate-50"
                onClick={(e) => {
                  e.stopPropagation();
                  mixpanelUtils.trackRowClick(
                    "Notification list item",
                    MIXPANEL_SCREENS.NOTIFICATIONS,
                    {
                      notification_type: NotificationType.EXPIRING_CANDIDATES,
                      surface: trackingSurface,
                    },
                  );
                  window.open(getCandidacyLink(candidacy), "_blank");
                }}
              >
                <Row className="items-center gap-1.5">
                  <Text className={cn("text-sm", isCompact && "text-xs")}>
                    {candidacy.candidateName}
                  </Text>
                  {bucket ? (
                    <AgenticScoreChip
                      bucket={bucket}
                      className="gap-0.5 px-1.5 py-0 text-[10px]"
                    />
                  ) : null}
                </Row>
                <Text className="text-xs font-normal text-slate-500">
                  {candidacy.customerName} &middot; {candidacy.reqTitle}
                </Text>
              </Column>
            );
          })}
        </Column>
      ) : null}
    </Column>
  );

  return render();
};
